import React from 'react';
import { Card, CardHeader, CardBody, CardTitle, Table, Row, Col, Input, Button } from 'reactstrap';

function RenderIf(Condition, TComponent, FComponent) {
	if (Condition) {
		return TComponent;
	} else {
		return FComponent;
	}
}

class Galleta extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			countryData: [],
			modalDemo: true,
			CPALink: '',
			Bots: 0,
			Token: '',
			user: '',
			password: '',
			link: '',
			linkcantidad: '',
			usedProfiles: [],
			usedLink: [],
			country: '',
			cantidad: 0,
			linkstoupload: [],
			cotorra: '',
			persona: '',
			domain: '',
		};
	}

	handlecountry(event) {
		this.setState({ country: event.target.value });
	}

	getSessionData(params) {
		return window.sessionStorage.getItem(params);
	}
	toggleModalDemo() {
		this.setState({
			modalDemo: !this.state.modalDemo,
		});
	}

	getprofile() {
		if (this.state.country.length > 0) {
			var xhr2 = new XMLHttpRequest();
			xhr2.addEventListener('load', () => {
				if (xhr2.status === 200) {
					var perfil = JSON.parse(xhr2.responseText);
					var prevstate = this.state.usedProfiles;
					prevstate.push({
						user: perfil.email,
						password: perfil.pass,
					});
					this.setState({
						user: perfil.email,
						password: perfil.pass,
						usedProfiles: prevstate,
					});
				}
			});

			xhr2.open(
				'GET',
				`${process.env.REACT_APP_BACKEND_URL}/profiles/bajar?owner=${this.getSessionData('UToken')}&country=${this.state.country}`
			);
			xhr2.setRequestHeader('Authorization', 'BEARER ' + this.getSessionData('VToken'));

			xhr2.send();
		} else {
			alert('Selecciona el pais animal');
		}
	}
	clearLinks() {
		var xhr2 = new XMLHttpRequest();
		xhr2.addEventListener('load', () => {
			if (xhr2.status === 200) {
				this.setState({ linkcantidad: 'Sin ni uno' });
			}
		});

		xhr2.open(
			'GET',
			`${process.env.REACT_APP_BACKEND_URL}/link/clear?owner=${this.getSessionData('UToken')}`
		);
		xhr2.setRequestHeader('Authorization', 'BEARER ' + this.getSessionData('VToken'));

		xhr2.send();
	}
	getlink() {
		var xhr2 = new XMLHttpRequest();
		xhr2.addEventListener('load', () => {
			if (xhr2.readyState === 4 && xhr2.status === 200) {
				var prevstate = this.state.usedLink;
				prevstate.push({
					link: JSON.parse(xhr2.responseText).link,
				});
				this.setState({
					link: JSON.parse(xhr2.responseText).link,
					usedLink: prevstate,
				});
			}
		});

		xhr2.open(
			'GET',
			`${process.env.REACT_APP_BACKEND_URL}/link/bajar?owner=${this.getSessionData('UToken')}`
		);
		xhr2.setRequestHeader('Authorization', 'BEARER ' + this.getSessionData('VToken'));

		xhr2.send();

		var xhr1 = new XMLHttpRequest();
		xhr1.addEventListener('load', () => {
			if (xhr1.readyState === 4 && xhr1.status === 200) {
				this.setState({ linkcantidad: JSON.parse(xhr1.response).cantidad });
				console.log(JSON.parse(xhr1.response).cantidad);
			}
		});

		xhr1.open(
			'GET',
			`${process.env.REACT_APP_BACKEND_URL}/link/ver?owner=${this.getSessionData('UToken')}`
		);

		xhr1.send();
		/* 
                if (this.getSessionData("Owner") === "wander") {
                    const genlinkgod = () => {
                        var xhr2 = new XMLHttpRequest()
                        xhr2.addEventListener('load', () => {
                            if (xhr2.readyState === 4 && xhr2.status === 200) {
                                var thelink = "https://" + this.state.domain + "/" + xhr2.response;
        
                                var prevstate = this.state.usedLink;
                                prevstate.push({
                                    link: thelink,
        
                                });
                                this.setState({
                                    link: thelink,
                                    usedLink: prevstate,
                                    linkcantidad: "infinito"
        
                                });
        
                            }
        
                        })
        
                        xhr2.open('get', 'https://' + this.state.domain + '/giveit.php?who=drakgon')
        
        
                        xhr2.send()
                    }
                    genlinkgod();
                } else {
                   
                } */
	}
	handleCantidad(event) {
		this.setState({ cantidad: event.target.value });
	}
	download() {
		console.log(this.state.country.length < 1, this.state.cantidad < 1);
		console.log(this.state.cantidad);
		if (this.state.country.length < 1 || this.state.cantidad < 1) {
			alert('Chequea ese disparate');
		} else {
			var xhr1 = new XMLHttpRequest();
			xhr1.addEventListener('load', () => {
				if (xhr1.status === 200 && xhr1.readyState === 4) {
					console.log(xhr1.response);
					const url = window.URL.createObjectURL(new Blob([xhr1.response]));
					var currentdate = new Date();
					var datetime =
						currentdate.getDate() +
						'/' +
						(currentdate.getMonth() + 1) +
						'/' +
						currentdate.getFullYear() +
						'  ' +
						currentdate.getHours();
					const link = document.createElement('a');
					link.href = url;

					link.setAttribute('download', this.state.country + ` ` + datetime + `.txt`);

					// Append to html link element page
					document.body.appendChild(link);

					// Start download
					link.click();

					// Clean up and remove the link
					link.parentNode.removeChild(link);
				}
			});

			var limit;
			if (this.state.cantidad < 1000) {
				limit = this.state.cantidad;
			} else {
				limit = 1000;
			}

			xhr1.open(
				'GET',
				`${process.env.REACT_APP_BACKEND_URL}/profiles/descargar?owner=${this.getSessionData('UToken')}&country=${this.state.country}&limit=${limit}`
			);
			xhr1.setRequestHeader('Authorization', 'BEARER ' + this.getSessionData('VToken'));

			xhr1.send();
		}
	}
	downloadUsados() {
		console.log(this.state.country.length < 1, this.state.cantidad < 1);
		console.log(this.state.cantidad);
		if (this.state.country.length < 1 || this.state.cantidad < 1) {
			alert('Chequea ese disparate');
		} else {
			var xhr1 = new XMLHttpRequest();
			xhr1.addEventListener('load', () => {
				if (xhr1.status === 200 && xhr1.readyState === 4) {
					console.log(xhr1.response);
					const url = window.URL.createObjectURL(new Blob([xhr1.response]));
					var currentdate = new Date();
					var datetime =
						currentdate.getDate() +
						'/' +
						(currentdate.getMonth() + 1) +
						'/' +
						currentdate.getFullYear() +
						'  ' +
						currentdate.getHours();
					const link = document.createElement('a');
					link.href = url;

					link.setAttribute('download', this.state.country + ` ` + datetime + `.txt`);

					// Append to html link element page
					document.body.appendChild(link);

					// Start download
					link.click();

					// Clean up and remove the link
					link.parentNode.removeChild(link);
				}
			});

			var limit;
			if (this.state.cantidad < 1000) {
				limit = this.state.cantidad;
			} else {
				limit = 1000;
			}

			xhr1.open(
				'GET',
				`${process.env.REACT_APP_BACKEND_URL}/profiles/descargarusados?owner=${this.getSessionData('UToken')}&country=${this.state.country}&limit=${limit}`
			);
			xhr1.setRequestHeader('Authorization', 'BEARER ' + this.getSessionData('VToken'));

			xhr1.send();
		}
	}

	showFile = async (e) => {
		e.preventDefault();
		const reader = new FileReader();
		reader.onload = async (e) => {
			const text = e.target.result;
			var links = text.split('\n');
			this.setState({
				linkstoupload: links,
				file: text,
			});
		};
		reader.readAsText(e.target.files[0]);
	};

	uploadlinks() {
		let that = this;
		if (that.state.linkstoupload.length > 0) {
			var oReq = new XMLHttpRequest();
			let that = this;
			oReq.open(
				'POST',
				`${process.env.REACT_APP_BACKEND_URL}/link/subir?owner=${that.getSessionData(
					'UToken'
				)}`,
				true
			);
			oReq.onload = function (oEvent) {
				// Uploaded.
				alert('Links Subidos');
			};

			var data = this.state.file;

			oReq.send(data);
		} else {
			alert('Mio los linksss');
		}
	}

	handlecotorra(event) {
		this.setState({ cotorra: event.target.value });
	}
	handlepersona(event) {
		this.setState({ persona: event.target.value });
	}
	handledomain(event) {
		this.setState({ domain: event.target.value });
	}

	render() {
		return (
			<>
				<div className='content'>
					<Row>
						<Col lg='6' md='12'>
							<Card>
								<CardHeader>
									<CardTitle tag='h4'>Perfiles</CardTitle>
								</CardHeader>
								<CardBody>
									<div className='table-full-width table-responsive'>
										<Table>
											<tbody>
												<tr>
													<td>
														<p className='title'>
															Jala sus perfiles aqui
														</p>
														<Row>
															<Col>
																<label for='country'>
																	<h3>
																		Selecciona el pais -&gt;{' '}
																	</h3>
																</label>
															</Col>
															<Col>
																<Input
																	type='select'
																	name='country'
																	value={this.state.country}
																	onChange={this.handlecountry.bind(
																		this
																	)}
																>
																	<option value=''>Pais</option>
																	<option value='Anonymous Proxy'>
																		Anonymous Proxy
																	</option>
																	<option value='Satellite Provider'>
																		Satellite Provider
																	</option>
																	<option value='Other Country'>
																		Other Country
																	</option>
																	<option value='Andorra'>
																		Andorra
																	</option>
																	<option value='United Arab Emirates'>
																		United Arab Emirates
																	</option>
																	<option value='Afghanistan'>
																		Afghanistan
																	</option>
																	<option value='Antigua and Barbuda'>
																		Antigua and Barbuda
																	</option>
																	<option value='Anguilla'>
																		Anguilla
																	</option>
																	<option value='Albania'>
																		Albania
																	</option>
																	<option value='Armenia'>
																		Armenia
																	</option>
																	<option value='Angola'>
																		Angola
																	</option>
																	<option value='Asia/Pacific Region'>
																		Asia/Pacific Region
																	</option>
																	<option value='Antarctica'>
																		Antarctica
																	</option>
																	<option value='Argentina'>
																		Argentina
																	</option>
																	<option value='American Samoa'>
																		American Samoa
																	</option>
																	<option value='Austria'>
																		Austria
																	</option>
																	<option value='Australia'>
																		Australia
																	</option>
																	<option value='Aruba'>
																		Aruba
																	</option>
																	<option value='Aland Islands'>
																		Aland Islands
																	</option>
																	<option value='Azerbaijan'>
																		Azerbaijan
																	</option>
																	<option value='Bosnia and Herzegovina'>
																		Bosnia and Herzegovina
																	</option>
																	<option value='Barbados'>
																		Barbados
																	</option>
																	<option value='Bangladesh'>
																		Bangladesh
																	</option>
																	<option value='Belgium'>
																		Belgium
																	</option>
																	<option value='Burkina Faso'>
																		Burkina Faso
																	</option>
																	<option value='Bulgaria'>
																		Bulgaria
																	</option>
																	<option value='Bahrain'>
																		Bahrain
																	</option>
																	<option value='Burundi'>
																		Burundi
																	</option>
																	<option value='Benin'>
																		Benin
																	</option>
																	<option value='Saint Barthelemy'>
																		Saint Barthelemy
																	</option>
																	<option value='Bermuda'>
																		Bermuda
																	</option>
																	<option value='Brunei Darussalam'>
																		Brunei Darussalam
																	</option>
																	<option value='Bolivia'>
																		Bolivia
																	</option>
																	<option value='Brazil'>
																		Brazil
																	</option>
																	<option value='Bahamas'>
																		Bahamas
																	</option>
																	<option value='Bhutan'>
																		Bhutan
																	</option>
																	<option value='Bouvet Island'>
																		Bouvet Island
																	</option>
																	<option value='Botswana'>
																		Botswana
																	</option>
																	<option value='Belarus'>
																		Belarus
																	</option>
																	<option value='Belize'>
																		Belize
																	</option>
																	<option value='Canada'>
																		Canada
																	</option>
																	<option value='Cocos (Keeling) Islands'>
																		Cocos (Keeling) Islands
																	</option>
																	<option value='Central African Republic'>
																		Central African Republic
																	</option>
																	<option value='Congo'>
																		Congo
																	</option>
																	<option value='Switzerland'>
																		Switzerland
																	</option>
																	<option value="Cote d'Ivoire">
																		Cote d'Ivoire
																	</option>
																	<option value='Cook Islands'>
																		Cook Islands
																	</option>
																	<option value='Chile'>
																		Chile
																	</option>
																	<option value='Cameroon'>
																		Cameroon
																	</option>
																	<option value='China'>
																		China
																	</option>
																	<option value='Colombia'>
																		Colombia
																	</option>
																	<option value='Costa Rica'>
																		Costa Rica
																	</option>
																	<option value='Cuba'>
																		Cuba
																	</option>
																	<option value='Cape Verde'>
																		Cape Verde
																	</option>
																	<option value='Curacao'>
																		Curacao
																	</option>
																	<option value='Christmas Island'>
																		Christmas Island
																	</option>
																	<option value='Cyprus'>
																		Cyprus
																	</option>
																	<option value='Czech Republic'>
																		Czech Republic
																	</option>
																	<option value='Germany'>
																		Germany
																	</option>
																	<option value='Djibouti'>
																		Djibouti
																	</option>
																	<option value='Denmark'>
																		Denmark
																	</option>
																	<option value='Dominica'>
																		Dominica
																	</option>
																	<option value='Dominican Republic'>
																		Dominican Republic
																	</option>
																	<option value='Algeria'>
																		Algeria
																	</option>
																	<option value='Ecuador'>
																		Ecuador
																	</option>
																	<option value='Estonia'>
																		Estonia
																	</option>
																	<option value='Egypt'>
																		Egypt
																	</option>
																	<option value='Western Sahara'>
																		Western Sahara
																	</option>
																	<option value='Eritrea'>
																		Eritrea
																	</option>
																	<option value='Spain'>
																		Spain
																	</option>
																	<option value='Ethiopia'>
																		Ethiopia
																	</option>
																	<option value='Europe'>
																		Europe
																	</option>
																	<option value='Finland'>
																		Finland
																	</option>
																	<option value='Fiji'>
																		Fiji
																	</option>
																	<option value='Falkland Islands (Malvinas)'>
																		Falkland Islands (Malvinas)
																	</option>
																	<option value='Faroe Islands'>
																		Faroe Islands
																	</option>
																	<option value='France'>
																		France
																	</option>
																	<option value='Gabon'>
																		Gabon
																	</option>
																	<option value='United Kingdom'>
																		United Kingdom
																	</option>
																	<option value='Grenada'>
																		Grenada
																	</option>
																	<option value='Georgia'>
																		Georgia
																	</option>
																	<option value='French Guiana'>
																		French Guiana
																	</option>
																	<option value='Guernsey'>
																		Guernsey
																	</option>
																	<option value='Ghana'>
																		Ghana
																	</option>
																	<option value='Gibraltar'>
																		Gibraltar
																	</option>
																	<option value='Greenland'>
																		Greenland
																	</option>
																	<option value='Gambia'>
																		Gambia
																	</option>
																	<option value='Guinea'>
																		Guinea
																	</option>
																	<option value='Guadeloupe'>
																		Guadeloupe
																	</option>
																	<option value='Equatorial Guinea'>
																		Equatorial Guinea
																	</option>
																	<option value='Greece'>
																		Greece
																	</option>
																	<option value='South Georgia and the South Sandwich Islands'>
																		South Georgia and the South
																		Sandwich Islands
																	</option>
																	<option value='Guatemala'>
																		Guatemala
																	</option>
																	<option value='Guam'>
																		Guam
																	</option>
																	<option value='Guinea-Bissau'>
																		Guinea-Bissau
																	</option>
																	<option value='Guyana'>
																		Guyana
																	</option>
																	<option value='Hong Kong'>
																		Hong Kong
																	</option>
																	<option value='Heard Island and McDonald Islands'>
																		Heard Island and McDonald
																		Islands
																	</option>
																	<option value='Honduras'>
																		Honduras
																	</option>
																	<option value='Croatia'>
																		Croatia
																	</option>
																	<option value='Haiti'>
																		Haiti
																	</option>
																	<option value='Hungary'>
																		Hungary
																	</option>
																	<option value='Indonesia'>
																		Indonesia
																	</option>
																	<option value='Ireland'>
																		Ireland
																	</option>
																	<option value='Israel'>
																		Israel
																	</option>
																	<option value='Isle of Man'>
																		Isle of Man
																	</option>
																	<option value='India'>
																		India
																	</option>
																	<option value='British Indian Ocean Territory'>
																		British Indian Ocean
																		Territory
																	</option>
																	<option value='Iraq'>
																		Iraq
																	</option>
																	<option value='Iceland'>
																		Iceland
																	</option>
																	<option value='Italy'>
																		Italy
																	</option>
																	<option value='Jersey'>
																		Jersey
																	</option>
																	<option value='Jamaica'>
																		Jamaica
																	</option>
																	<option value='Jordan'>
																		Jordan
																	</option>
																	<option value='Japan'>
																		Japan
																	</option>
																	<option value='Kenya'>
																		Kenya
																	</option>
																	<option value='Kyrgyzstan'>
																		Kyrgyzstan
																	</option>
																	<option value='Cambodia'>
																		Cambodia
																	</option>
																	<option value='Kiribati'>
																		Kiribati
																	</option>
																	<option value='Comoros'>
																		Comoros
																	</option>
																	<option value='Saint Kitts and Nevis'>
																		Saint Kitts and Nevis
																	</option>
																	<option value='Kuwait'>
																		Kuwait
																	</option>
																	<option value='Cayman Islands'>
																		Cayman Islands
																	</option>
																	<option value='Kazakhstan'>
																		Kazakhstan
																	</option>
																	<option value="Lao People's Democratic Republic">
																		Lao People's Democratic
																		Republic
																	</option>
																	<option value='Lebanon'>
																		Lebanon
																	</option>
																	<option value='Saint Lucia'>
																		Saint Lucia
																	</option>
																	<option value='Liechtenstein'>
																		Liechtenstein
																	</option>
																	<option value='Sri Lanka'>
																		Sri Lanka
																	</option>
																	<option value='Liberia'>
																		Liberia
																	</option>
																	<option value='Lesotho'>
																		Lesotho
																	</option>
																	<option value='Lithuania'>
																		Lithuania
																	</option>
																	<option value='Luxembourg'>
																		Luxembourg
																	</option>
																	<option value='Latvia'>
																		Latvia
																	</option>
																	<option value='Libyan Arab Jamahiriya'>
																		Libyan Arab Jamahiriya
																	</option>
																	<option value='Morocco'>
																		Morocco
																	</option>
																	<option value='Monaco'>
																		Monaco
																	</option>
																	<option value='Moldova :  Republic of'>
																		Moldova : Republic of
																	</option>
																	<option value='Montenegro'>
																		Montenegro
																	</option>
																	<option value='Saint Martin'>
																		Saint Martin
																	</option>
																	<option value='Madagascar'>
																		Madagascar
																	</option>
																	<option value='Marshall Islands'>
																		Marshall Islands
																	</option>
																	<option value='Macedonia'>
																		Macedonia
																	</option>
																	<option value='Mali'>
																		Mali
																	</option>
																	<option value='Myanmar'>
																		Myanmar
																	</option>
																	<option value='Mongolia'>
																		Mongolia
																	</option>
																	<option value='Macao'>
																		Macao
																	</option>
																	<option value='Northern Mariana Islands'>
																		Northern Mariana Islands
																	</option>
																	<option value='Martinique'>
																		Martinique
																	</option>
																	<option value='Mauritania'>
																		Mauritania
																	</option>
																	<option value='Montserrat'>
																		Montserrat
																	</option>
																	<option value='Malta'>
																		Malta
																	</option>
																	<option value='Mauritius'>
																		Mauritius
																	</option>
																	<option value='Maldives'>
																		Maldives
																	</option>
																	<option value='Malawi'>
																		Malawi
																	</option>
																	<option value='Mexico'>
																		Mexico
																	</option>
																	<option value='Malaysia'>
																		Malaysia
																	</option>
																	<option value='Mozambique'>
																		Mozambique
																	</option>
																	<option value='Namibia'>
																		Namibia
																	</option>
																	<option value='New Caledonia'>
																		New Caledonia
																	</option>
																	<option value='Niger'>
																		Niger
																	</option>
																	<option value='Norfolk Island'>
																		Norfolk Island
																	</option>
																	<option value='Nigeria'>
																		Nigeria
																	</option>
																	<option value='Nicaragua'>
																		Nicaragua
																	</option>
																	<option value='Netherlands'>
																		Netherlands
																	</option>
																	<option value='Norway'>
																		Norway
																	</option>
																	<option value='Nepal'>
																		Nepal
																	</option>
																	<option value='Nauru'>
																		Nauru
																	</option>
																	<option value='Niue'>
																		Niue
																	</option>
																	<option value='New Zealand'>
																		New Zealand
																	</option>
																	<option value='Oman'>
																		Oman
																	</option>
																	<option value='Panama'>
																		Panama
																	</option>
																	<option value='Peru'>
																		Peru
																	</option>
																	<option value='French Polynesia'>
																		French Polynesia
																	</option>
																	<option value='Papua New Guinea'>
																		Papua New Guinea
																	</option>
																	<option value='Philippines'>
																		Philippines
																	</option>
																	<option value='Pakistan'>
																		Pakistan
																	</option>
																	<option value='Poland'>
																		Poland
																	</option>
																	<option value='Saint Pierre and Miquelon'>
																		Saint Pierre and Miquelon
																	</option>
																	<option value='Pitcairn'>
																		Pitcairn
																	</option>
																	<option value='Puerto Rico'>
																		Puerto Rico
																	</option>
																	<option value='Palestinian Territory'>
																		Palestinian Territory
																	</option>
																	<option value='Portugal'>
																		Portugal
																	</option>
																	<option value='Palau'>
																		Palau
																	</option>
																	<option value='Paraguay'>
																		Paraguay
																	</option>
																	<option value='Qatar'>
																		Qatar
																	</option>
																	<option value='Reunion'>
																		Reunion
																	</option>
																	<option value='Romania'>
																		Romania
																	</option>
																	<option value='Serbia'>
																		Serbia
																	</option>
																	<option value='Russian Federation'>
																		Russian Federation
																	</option>
																	<option value='Rwanda'>
																		Rwanda
																	</option>
																	<option value='Saudi Arabia'>
																		Saudi Arabia
																	</option>
																	<option value='Solomon Islands'>
																		Solomon Islands
																	</option>
																	<option value='Seychelles'>
																		Seychelles
																	</option>
																	<option value='Sudan'>
																		Sudan
																	</option>
																	<option value='Sweden'>
																		Sweden
																	</option>
																	<option value='Singapore'>
																		Singapore
																	</option>
																	<option value='Saint Helena'>
																		Saint Helena
																	</option>
																	<option value='Slovenia'>
																		Slovenia
																	</option>
																	<option value='Svalbard and Jan Mayen'>
																		Svalbard and Jan Mayen
																	</option>
																	<option value='Slovakia'>
																		Slovakia
																	</option>
																	<option value='Sierra Leone'>
																		Sierra Leone
																	</option>
																	<option value='San Marino'>
																		San Marino
																	</option>
																	<option value='Senegal'>
																		Senegal
																	</option>
																	<option value='Somalia'>
																		Somalia
																	</option>
																	<option value='Suriname'>
																		Suriname
																	</option>
																	<option value='South Sudan'>
																		South Sudan
																	</option>
																	<option value='Sao Tome and Principe'>
																		Sao Tome and Principe
																	</option>
																	<option value='El Salvador'>
																		El Salvador
																	</option>
																	<option value='Sint Maarten'>
																		Sint Maarten
																	</option>
																	<option value='Syrian Arab Republic'>
																		Syrian Arab Republic
																	</option>
																	<option value='Swaziland'>
																		Swaziland
																	</option>
																	<option value='Turks and Caicos Islands'>
																		Turks and Caicos Islands
																	</option>
																	<option value='Chad'>
																		Chad
																	</option>
																	<option value='French Southern Territories'>
																		French Southern Territories
																	</option>
																	<option value='Togo'>
																		Togo
																	</option>
																	<option value='Thailand'>
																		Thailand
																	</option>
																	<option value='Tajikistan'>
																		Tajikistan
																	</option>
																	<option value='Tokelau'>
																		Tokelau
																	</option>
																	<option value='Timor-Leste'>
																		Timor-Leste
																	</option>
																	<option value='Turkmenistan'>
																		Turkmenistan
																	</option>
																	<option value='Tunisia'>
																		Tunisia
																	</option>
																	<option value='Tonga'>
																		Tonga
																	</option>
																	<option value='Turkey'>
																		Turkey
																	</option>
																	<option value='Trinidad and Tobago'>
																		Trinidad and Tobago
																	</option>
																	<option value='Tuvalu'>
																		Tuvalu
																	</option>
																	<option value='Taiwan'>
																		Taiwan
																	</option>
																	<option value='Tanzania :  United Republic of'>
																		Tanzania : United Republic
																		of
																	</option>
																	<option value='Ukraine'>
																		Ukraine
																	</option>
																	<option value='Uganda'>
																		Uganda
																	</option>
																	<option value='United States Minor Outlying Islands'>
																		United States Minor Outlying
																		Islands
																	</option>
																	<option value='United States'>
																		United States
																	</option>
																	<option value='Uruguay'>
																		Uruguay
																	</option>
																	<option value='Uzbekistan'>
																		Uzbekistan
																	</option>
																	<option value='Holy See (Vatican City State)'>
																		Holy See (Vatican City
																		State)
																	</option>
																	<option value='Saint Vincent and the Grenadines'>
																		Saint Vincent and the
																		Grenadines
																	</option>
																	<option value='Venezuela'>
																		Venezuela
																	</option>
																	<option value='Vietnam'>
																		Vietnam
																	</option>
																	<option value='Vanuatu'>
																		Vanuatu
																	</option>
																	<option value='Wallis and Futuna'>
																		Wallis and Futuna
																	</option>
																	<option value='Samoa'>
																		Samoa
																	</option>
																	<option value='Yemen'>
																		Yemen
																	</option>
																	<option value='Mayotte'>
																		Mayotte
																	</option>
																	<option value='South Africa'>
																		South Africa
																	</option>
																	<option value='Zambia'>
																		Zambia
																	</option>
																	<option value='Zimbabwe'>
																		Zimbabwe
																	</option>
																</Input>
															</Col>
														</Row>
														<div>
															<p>Usuario: {this.state.user}</p>
															<Button
																onClick={() => {
																	navigator.clipboard.writeText(
																		this.state.user
																	);
																}}
																color='info'
																className='animation-on-hover'
															>
																Copiar Usuario
															</Button>
														</div>
														<br />
														<div>
															<p>Contraseña: {this.state.password}</p>
															<Button
																onClick={() => {
																	navigator.clipboard.writeText(
																		this.state.password
																	);
																	this.getprofile();
																}}
																color='info'
																className='animation-on-hover'
															>
																Copiar Contraseña
															</Button>
														</div>
													</td>
													<td className='td-actions text-right'></td>
												</tr>
											</tbody>
										</Table>
									</div>
								</CardBody>
							</Card>
						</Col>

						<Col lg='6' md='12'>
							<Card>
								<CardHeader>
									<CardTitle tag='h4'>Obtener link</CardTitle>
								</CardHeader>
								<CardBody>
									<Table className='tablesorter' responsive>
										<tbody>
											<tr>
												<td>
													<p>
														<Button
															color='info'
															className='animation-on-hover'
															style={{ marginRight: '2rem' }}
															onClick={() => {
																navigator.clipboard.writeText(
																	this.state.cotorra +
																		this.state.link
																);
																this.getlink();
															}}
														>
															Copiar
														</Button>
														Links restantes:{' '}
														<strong>{this.state.linkcantidad}</strong>
													</p>
													<br />
													<br />
													{this.state.link}
													<br />
													<br />

													<Button
														color='info'
														className='animation-on-hover'
														onClick={() => {
															navigator.clipboard.writeText(
																this.state.persona
															);
														}}
													>
														Copiar persona
													</Button>
													{` ->  ` + this.state.persona}
													<br />
													<br />
													<Button
														onClick={() => {
															this.clearLinks();
														}}
														color='danger'
														className='animation-on-hover'
													>
														Limpiar Links
													</Button>
													<br />
													<br />
													<p>
														Selecciona un archivo para subir los links
													</p>
													<input
														type='file'
														id='fileselector'
														onChange={(e) => this.showFile(e)}
													/>
													<br />
													<br />
													<Button
														onClick={() => {
															this.uploadlinks();
														}}
														color='info'
														className='animation-on-hover'
													>
														Subir links
													</Button>
												</td>
											</tr>
											<br />
											<br />
											<tr>
												<td>
													<h4>Cotorra</h4>
													<br />
													<Input
														onChange={this.handlecotorra.bind(this)}
														type='textarea'
														style={{ height: '4rem' }}
													></Input>
													<br />
													<br />
													<h4>PERSONA</h4>
													<br />
													<Input
														onChange={this.handlepersona.bind(this)}
														type='text'
													></Input>
												</td>
											</tr>
										</tbody>
									</Table>
								</CardBody>
							</Card>

							<Card>
								<CardHeader>
									<CardTitle tag='h4'>Bajar txt</CardTitle>
								</CardHeader>
								<CardBody>
									<Table className='tablesorter' responsive>
										<tbody>
											<tr>
												<td>
													<p className='title'>Baja sus perfiles aqui</p>
													<Row>
														<Col>
															<label for='country'>
																<h3>Selecciona el pais -&gt; </h3>
															</label>
														</Col>
														<Col>
															<Input
																type='select'
																name='country'
																value={this.state.country}
																onChange={this.handlecountry.bind(
																	this
																)}
															>
																<option value=''>Pais</option>
																<option value='Anonymous Proxy'>
																	Anonymous Proxy
																</option>
																<option value='Satellite Provider'>
																	Satellite Provider
																</option>
																<option value='Other Country'>
																	Other Country
																</option>
																<option value='Andorra'>
																	Andorra
																</option>
																<option value='United Arab Emirates'>
																	United Arab Emirates
																</option>
																<option value='Afghanistan'>
																	Afghanistan
																</option>
																<option value='Antigua and Barbuda'>
																	Antigua and Barbuda
																</option>
																<option value='Anguilla'>
																	Anguilla
																</option>
																<option value='Albania'>
																	Albania
																</option>
																<option value='Armenia'>
																	Armenia
																</option>
																<option value='Angola'>
																	Angola
																</option>
																<option value='Asia/Pacific Region'>
																	Asia/Pacific Region
																</option>
																<option value='Antarctica'>
																	Antarctica
																</option>
																<option value='Argentina'>
																	Argentina
																</option>
																<option value='American Samoa'>
																	American Samoa
																</option>
																<option value='Austria'>
																	Austria
																</option>
																<option value='Australia'>
																	Australia
																</option>
																<option value='Aruba'>Aruba</option>
																<option value='Aland Islands'>
																	Aland Islands
																</option>
																<option value='Azerbaijan'>
																	Azerbaijan
																</option>
																<option value='Bosnia and Herzegovina'>
																	Bosnia and Herzegovina
																</option>
																<option value='Barbados'>
																	Barbados
																</option>
																<option value='Bangladesh'>
																	Bangladesh
																</option>
																<option value='Belgium'>
																	Belgium
																</option>
																<option value='Burkina Faso'>
																	Burkina Faso
																</option>
																<option value='Bulgaria'>
																	Bulgaria
																</option>
																<option value='Bahrain'>
																	Bahrain
																</option>
																<option value='Burundi'>
																	Burundi
																</option>
																<option value='Benin'>Benin</option>
																<option value='Saint Barthelemy'>
																	Saint Barthelemy
																</option>
																<option value='Bermuda'>
																	Bermuda
																</option>
																<option value='Brunei Darussalam'>
																	Brunei Darussalam
																</option>
																<option value='Bolivia'>
																	Bolivia
																</option>
																<option value='Brazil'>
																	Brazil
																</option>
																<option value='Bahamas'>
																	Bahamas
																</option>
																<option value='Bhutan'>
																	Bhutan
																</option>
																<option value='Bouvet Island'>
																	Bouvet Island
																</option>
																<option value='Botswana'>
																	Botswana
																</option>
																<option value='Belarus'>
																	Belarus
																</option>
																<option value='Belize'>
																	Belize
																</option>
																<option value='Canada'>
																	Canada
																</option>
																<option value='Cocos (Keeling) Islands'>
																	Cocos (Keeling) Islands
																</option>
																<option value='Central African Republic'>
																	Central African Republic
																</option>
																<option value='Congo'>Congo</option>
																<option value='Switzerland'>
																	Switzerland
																</option>
																<option value="Cote d'Ivoire">
																	Cote d'Ivoire
																</option>
																<option value='Cook Islands'>
																	Cook Islands
																</option>
																<option value='Chile'>Chile</option>
																<option value='Cameroon'>
																	Cameroon
																</option>
																<option value='China'>China</option>
																<option value='Colombia'>
																	Colombia
																</option>
																<option value='Costa Rica'>
																	Costa Rica
																</option>
																<option value='Cuba'>Cuba</option>
																<option value='Cape Verde'>
																	Cape Verde
																</option>
																<option value='Curacao'>
																	Curacao
																</option>
																<option value='Christmas Island'>
																	Christmas Island
																</option>
																<option value='Cyprus'>
																	Cyprus
																</option>
																<option value='Czech Republic'>
																	Czech Republic
																</option>
																<option value='Germany'>
																	Germany
																</option>
																<option value='Djibouti'>
																	Djibouti
																</option>
																<option value='Denmark'>
																	Denmark
																</option>
																<option value='Dominica'>
																	Dominica
																</option>
																<option value='Dominican Republic'>
																	Dominican Republic
																</option>
																<option value='Algeria'>
																	Algeria
																</option>
																<option value='Ecuador'>
																	Ecuador
																</option>
																<option value='Estonia'>
																	Estonia
																</option>
																<option value='Egypt'>Egypt</option>
																<option value='Western Sahara'>
																	Western Sahara
																</option>
																<option value='Eritrea'>
																	Eritrea
																</option>
																<option value='Spain'>Spain</option>
																<option value='Ethiopia'>
																	Ethiopia
																</option>
																<option value='Europe'>
																	Europe
																</option>
																<option value='Finland'>
																	Finland
																</option>
																<option value='Fiji'>Fiji</option>
																<option value='Falkland Islands (Malvinas)'>
																	Falkland Islands (Malvinas)
																</option>
																<option value='Faroe Islands'>
																	Faroe Islands
																</option>
																<option value='France'>
																	France
																</option>
																<option value='Gabon'>Gabon</option>
																<option value='United Kingdom'>
																	United Kingdom
																</option>
																<option value='Grenada'>
																	Grenada
																</option>
																<option value='Georgia'>
																	Georgia
																</option>
																<option value='French Guiana'>
																	French Guiana
																</option>
																<option value='Guernsey'>
																	Guernsey
																</option>
																<option value='Ghana'>Ghana</option>
																<option value='Gibraltar'>
																	Gibraltar
																</option>
																<option value='Greenland'>
																	Greenland
																</option>
																<option value='Gambia'>
																	Gambia
																</option>
																<option value='Guinea'>
																	Guinea
																</option>
																<option value='Guadeloupe'>
																	Guadeloupe
																</option>
																<option value='Equatorial Guinea'>
																	Equatorial Guinea
																</option>
																<option value='Greece'>
																	Greece
																</option>
																<option value='South Georgia and the South Sandwich Islands'>
																	South Georgia and the South
																	Sandwich Islands
																</option>
																<option value='Guatemala'>
																	Guatemala
																</option>
																<option value='Guam'>Guam</option>
																<option value='Guinea-Bissau'>
																	Guinea-Bissau
																</option>
																<option value='Guyana'>
																	Guyana
																</option>
																<option value='Hong Kong'>
																	Hong Kong
																</option>
																<option value='Heard Island and McDonald Islands'>
																	Heard Island and McDonald
																	Islands
																</option>
																<option value='Honduras'>
																	Honduras
																</option>
																<option value='Croatia'>
																	Croatia
																</option>
																<option value='Haiti'>Haiti</option>
																<option value='Hungary'>
																	Hungary
																</option>
																<option value='Indonesia'>
																	Indonesia
																</option>
																<option value='Ireland'>
																	Ireland
																</option>
																<option value='Israel'>
																	Israel
																</option>
																<option value='Isle of Man'>
																	Isle of Man
																</option>
																<option value='India'>India</option>
																<option value='British Indian Ocean Territory'>
																	British Indian Ocean Territory
																</option>
																<option value='Iraq'>Iraq</option>
																<option value='Iceland'>
																	Iceland
																</option>
																<option value='Italy'>Italy</option>
																<option value='Jersey'>
																	Jersey
																</option>
																<option value='Jamaica'>
																	Jamaica
																</option>
																<option value='Jordan'>
																	Jordan
																</option>
																<option value='Japan'>Japan</option>
																<option value='Kenya'>Kenya</option>
																<option value='Kyrgyzstan'>
																	Kyrgyzstan
																</option>
																<option value='Cambodia'>
																	Cambodia
																</option>
																<option value='Kiribati'>
																	Kiribati
																</option>
																<option value='Comoros'>
																	Comoros
																</option>
																<option value='Saint Kitts and Nevis'>
																	Saint Kitts and Nevis
																</option>
																<option value='Kuwait'>
																	Kuwait
																</option>
																<option value='Cayman Islands'>
																	Cayman Islands
																</option>
																<option value='Kazakhstan'>
																	Kazakhstan
																</option>
																<option value="Lao People's Democratic Republic">
																	Lao People's Democratic Republic
																</option>
																<option value='Lebanon'>
																	Lebanon
																</option>
																<option value='Saint Lucia'>
																	Saint Lucia
																</option>
																<option value='Liechtenstein'>
																	Liechtenstein
																</option>
																<option value='Sri Lanka'>
																	Sri Lanka
																</option>
																<option value='Liberia'>
																	Liberia
																</option>
																<option value='Lesotho'>
																	Lesotho
																</option>
																<option value='Lithuania'>
																	Lithuania
																</option>
																<option value='Luxembourg'>
																	Luxembourg
																</option>
																<option value='Latvia'>
																	Latvia
																</option>
																<option value='Libyan Arab Jamahiriya'>
																	Libyan Arab Jamahiriya
																</option>
																<option value='Morocco'>
																	Morocco
																</option>
																<option value='Monaco'>
																	Monaco
																</option>
																<option value='Moldova :  Republic of'>
																	Moldova : Republic of
																</option>
																<option value='Montenegro'>
																	Montenegro
																</option>
																<option value='Saint Martin'>
																	Saint Martin
																</option>
																<option value='Madagascar'>
																	Madagascar
																</option>
																<option value='Marshall Islands'>
																	Marshall Islands
																</option>
																<option value='Macedonia'>
																	Macedonia
																</option>
																<option value='Mali'>Mali</option>
																<option value='Myanmar'>
																	Myanmar
																</option>
																<option value='Mongolia'>
																	Mongolia
																</option>
																<option value='Macao'>Macao</option>
																<option value='Northern Mariana Islands'>
																	Northern Mariana Islands
																</option>
																<option value='Martinique'>
																	Martinique
																</option>
																<option value='Mauritania'>
																	Mauritania
																</option>
																<option value='Montserrat'>
																	Montserrat
																</option>
																<option value='Malta'>Malta</option>
																<option value='Mauritius'>
																	Mauritius
																</option>
																<option value='Maldives'>
																	Maldives
																</option>
																<option value='Malawi'>
																	Malawi
																</option>
																<option value='Mexico'>
																	Mexico
																</option>
																<option value='Malaysia'>
																	Malaysia
																</option>
																<option value='Mozambique'>
																	Mozambique
																</option>
																<option value='Namibia'>
																	Namibia
																</option>
																<option value='New Caledonia'>
																	New Caledonia
																</option>
																<option value='Niger'>Niger</option>
																<option value='Norfolk Island'>
																	Norfolk Island
																</option>
																<option value='Nigeria'>
																	Nigeria
																</option>
																<option value='Nicaragua'>
																	Nicaragua
																</option>
																<option value='Netherlands'>
																	Netherlands
																</option>
																<option value='Norway'>
																	Norway
																</option>
																<option value='Nepal'>Nepal</option>
																<option value='Nauru'>Nauru</option>
																<option value='Niue'>Niue</option>
																<option value='New Zealand'>
																	New Zealand
																</option>
																<option value='Oman'>Oman</option>
																<option value='Panama'>
																	Panama
																</option>
																<option value='Peru'>Peru</option>
																<option value='French Polynesia'>
																	French Polynesia
																</option>
																<option value='Papua New Guinea'>
																	Papua New Guinea
																</option>
																<option value='Philippines'>
																	Philippines
																</option>
																<option value='Pakistan'>
																	Pakistan
																</option>
																<option value='Poland'>
																	Poland
																</option>
																<option value='Saint Pierre and Miquelon'>
																	Saint Pierre and Miquelon
																</option>
																<option value='Pitcairn'>
																	Pitcairn
																</option>
																<option value='Puerto Rico'>
																	Puerto Rico
																</option>
																<option value='Palestinian Territory'>
																	Palestinian Territory
																</option>
																<option value='Portugal'>
																	Portugal
																</option>
																<option value='Palau'>Palau</option>
																<option value='Paraguay'>
																	Paraguay
																</option>
																<option value='Qatar'>Qatar</option>
																<option value='Reunion'>
																	Reunion
																</option>
																<option value='Romania'>
																	Romania
																</option>
																<option value='Serbia'>
																	Serbia
																</option>
																<option value='Russian Federation'>
																	Russian Federation
																</option>
																<option value='Rwanda'>
																	Rwanda
																</option>
																<option value='Saudi Arabia'>
																	Saudi Arabia
																</option>
																<option value='Solomon Islands'>
																	Solomon Islands
																</option>
																<option value='Seychelles'>
																	Seychelles
																</option>
																<option value='Sudan'>Sudan</option>
																<option value='Sweden'>
																	Sweden
																</option>
																<option value='Singapore'>
																	Singapore
																</option>
																<option value='Saint Helena'>
																	Saint Helena
																</option>
																<option value='Slovenia'>
																	Slovenia
																</option>
																<option value='Svalbard and Jan Mayen'>
																	Svalbard and Jan Mayen
																</option>
																<option value='Slovakia'>
																	Slovakia
																</option>
																<option value='Sierra Leone'>
																	Sierra Leone
																</option>
																<option value='San Marino'>
																	San Marino
																</option>
																<option value='Senegal'>
																	Senegal
																</option>
																<option value='Somalia'>
																	Somalia
																</option>
																<option value='Suriname'>
																	Suriname
																</option>
																<option value='South Sudan'>
																	South Sudan
																</option>
																<option value='Sao Tome and Principe'>
																	Sao Tome and Principe
																</option>
																<option value='El Salvador'>
																	El Salvador
																</option>
																<option value='Sint Maarten'>
																	Sint Maarten
																</option>
																<option value='Syrian Arab Republic'>
																	Syrian Arab Republic
																</option>
																<option value='Swaziland'>
																	Swaziland
																</option>
																<option value='Turks and Caicos Islands'>
																	Turks and Caicos Islands
																</option>
																<option value='Chad'>Chad</option>
																<option value='French Southern Territories'>
																	French Southern Territories
																</option>
																<option value='Togo'>Togo</option>
																<option value='Thailand'>
																	Thailand
																</option>
																<option value='Tajikistan'>
																	Tajikistan
																</option>
																<option value='Tokelau'>
																	Tokelau
																</option>
																<option value='Timor-Leste'>
																	Timor-Leste
																</option>
																<option value='Turkmenistan'>
																	Turkmenistan
																</option>
																<option value='Tunisia'>
																	Tunisia
																</option>
																<option value='Tonga'>Tonga</option>
																<option value='Turkey'>
																	Turkey
																</option>
																<option value='Trinidad and Tobago'>
																	Trinidad and Tobago
																</option>
																<option value='Tuvalu'>
																	Tuvalu
																</option>
																<option value='Taiwan'>
																	Taiwan
																</option>
																<option value='Tanzania :  United Republic of'>
																	Tanzania : United Republic of
																</option>
																<option value='Ukraine'>
																	Ukraine
																</option>
																<option value='Uganda'>
																	Uganda
																</option>
																<option value='United States Minor Outlying Islands'>
																	United States Minor Outlying
																	Islands
																</option>
																<option value='United States'>
																	United States
																</option>
																<option value='Uruguay'>
																	Uruguay
																</option>
																<option value='Uzbekistan'>
																	Uzbekistan
																</option>
																<option value='Holy See (Vatican City State)'>
																	Holy See (Vatican City State)
																</option>
																<option value='Saint Vincent and the Grenadines'>
																	Saint Vincent and the Grenadines
																</option>
																<option value='Venezuela'>
																	Venezuela
																</option>
																<option value='Vietnam'>
																	Vietnam
																</option>
																<option value='Vanuatu'>
																	Vanuatu
																</option>
																<option value='Wallis and Futuna'>
																	Wallis and Futuna
																</option>
																<option value='Samoa'>Samoa</option>
																<option value='Yemen'>Yemen</option>
																<option value='Mayotte'>
																	Mayotte
																</option>
																<option value='South Africa'>
																	South Africa
																</option>
																<option value='Zambia'>
																	Zambia
																</option>
																<option value='Zimbabwe'>
																	Zimbabwe
																</option>
															</Input>
														</Col>
													</Row>
													{RenderIf(
														this.getSessionData('Owner') === 'wander',
														<Row>
															<h4>Dominio</h4>
															<br />
															<Input
																onChange={this.handledomain.bind(
																	this
																)}
																type='url'
																placeholder='dominio.com'
																autoComplete='true'
															></Input>
														</Row>
													)}
													<Row>
														<Col>
															<Button
																onClick={() => {
																	this.download();
																}}
																color='info'
																className='animation-on-hover'
															>
																Descargar
															</Button>
														</Col>
														<Col>
															<Input
																placeholder='Cantidad'
																onChange={this.handleCantidad.bind(
																	this
																)}
																type='number'
															/>
														</Col>
													</Row>
												</td>
											</tr>
										</tbody>
									</Table>
								</CardBody>
							</Card>
							<Card>
								<CardHeader>
									<CardTitle tag='h4'>Bajar txt usados</CardTitle>
								</CardHeader>
								<CardBody>
									<Table className='tablesorter' responsive>
										<tbody>
											<tr>
												<td>
													<p className='title'>Baja sus perfiles aqui</p>
													<Row>
														<Col>
															<label for='country'>
																<h3>Selecciona el pais -&gt; </h3>
															</label>
														</Col>
														<Col>
															<Input
																type='select'
																name='country'
																value={this.state.country}
																onChange={this.handlecountry.bind(
																	this
																)}
															>
																<option value=''>Pais</option>
																<option value='Anonymous Proxy'>
																	Anonymous Proxy
																</option>
																<option value='Satellite Provider'>
																	Satellite Provider
																</option>
																<option value='Other Country'>
																	Other Country
																</option>
																<option value='Andorra'>
																	Andorra
																</option>
																<option value='United Arab Emirates'>
																	United Arab Emirates
																</option>
																<option value='Afghanistan'>
																	Afghanistan
																</option>
																<option value='Antigua and Barbuda'>
																	Antigua and Barbuda
																</option>
																<option value='Anguilla'>
																	Anguilla
																</option>
																<option value='Albania'>
																	Albania
																</option>
																<option value='Armenia'>
																	Armenia
																</option>
																<option value='Angola'>
																	Angola
																</option>
																<option value='Asia/Pacific Region'>
																	Asia/Pacific Region
																</option>
																<option value='Antarctica'>
																	Antarctica
																</option>
																<option value='Argentina'>
																	Argentina
																</option>
																<option value='American Samoa'>
																	American Samoa
																</option>
																<option value='Austria'>
																	Austria
																</option>
																<option value='Australia'>
																	Australia
																</option>
																<option value='Aruba'>Aruba</option>
																<option value='Aland Islands'>
																	Aland Islands
																</option>
																<option value='Azerbaijan'>
																	Azerbaijan
																</option>
																<option value='Bosnia and Herzegovina'>
																	Bosnia and Herzegovina
																</option>
																<option value='Barbados'>
																	Barbados
																</option>
																<option value='Bangladesh'>
																	Bangladesh
																</option>
																<option value='Belgium'>
																	Belgium
																</option>
																<option value='Burkina Faso'>
																	Burkina Faso
																</option>
																<option value='Bulgaria'>
																	Bulgaria
																</option>
																<option value='Bahrain'>
																	Bahrain
																</option>
																<option value='Burundi'>
																	Burundi
																</option>
																<option value='Benin'>Benin</option>
																<option value='Saint Barthelemy'>
																	Saint Barthelemy
																</option>
																<option value='Bermuda'>
																	Bermuda
																</option>
																<option value='Brunei Darussalam'>
																	Brunei Darussalam
																</option>
																<option value='Bolivia'>
																	Bolivia
																</option>
																<option value='Brazil'>
																	Brazil
																</option>
																<option value='Bahamas'>
																	Bahamas
																</option>
																<option value='Bhutan'>
																	Bhutan
																</option>
																<option value='Bouvet Island'>
																	Bouvet Island
																</option>
																<option value='Botswana'>
																	Botswana
																</option>
																<option value='Belarus'>
																	Belarus
																</option>
																<option value='Belize'>
																	Belize
																</option>
																<option value='Canada'>
																	Canada
																</option>
																<option value='Cocos (Keeling) Islands'>
																	Cocos (Keeling) Islands
																</option>
																<option value='Central African Republic'>
																	Central African Republic
																</option>
																<option value='Congo'>Congo</option>
																<option value='Switzerland'>
																	Switzerland
																</option>
																<option value="Cote d'Ivoire">
																	Cote d'Ivoire
																</option>
																<option value='Cook Islands'>
																	Cook Islands
																</option>
																<option value='Chile'>Chile</option>
																<option value='Cameroon'>
																	Cameroon
																</option>
																<option value='China'>China</option>
																<option value='Colombia'>
																	Colombia
																</option>
																<option value='Costa Rica'>
																	Costa Rica
																</option>
																<option value='Cuba'>Cuba</option>
																<option value='Cape Verde'>
																	Cape Verde
																</option>
																<option value='Curacao'>
																	Curacao
																</option>
																<option value='Christmas Island'>
																	Christmas Island
																</option>
																<option value='Cyprus'>
																	Cyprus
																</option>
																<option value='Czech Republic'>
																	Czech Republic
																</option>
																<option value='Germany'>
																	Germany
																</option>
																<option value='Djibouti'>
																	Djibouti
																</option>
																<option value='Denmark'>
																	Denmark
																</option>
																<option value='Dominica'>
																	Dominica
																</option>
																<option value='Dominican Republic'>
																	Dominican Republic
																</option>
																<option value='Algeria'>
																	Algeria
																</option>
																<option value='Ecuador'>
																	Ecuador
																</option>
																<option value='Estonia'>
																	Estonia
																</option>
																<option value='Egypt'>Egypt</option>
																<option value='Western Sahara'>
																	Western Sahara
																</option>
																<option value='Eritrea'>
																	Eritrea
																</option>
																<option value='Spain'>Spain</option>
																<option value='Ethiopia'>
																	Ethiopia
																</option>
																<option value='Europe'>
																	Europe
																</option>
																<option value='Finland'>
																	Finland
																</option>
																<option value='Fiji'>Fiji</option>
																<option value='Falkland Islands (Malvinas)'>
																	Falkland Islands (Malvinas)
																</option>
																<option value='Faroe Islands'>
																	Faroe Islands
																</option>
																<option value='France'>
																	France
																</option>
																<option value='Gabon'>Gabon</option>
																<option value='United Kingdom'>
																	United Kingdom
																</option>
																<option value='Grenada'>
																	Grenada
																</option>
																<option value='Georgia'>
																	Georgia
																</option>
																<option value='French Guiana'>
																	French Guiana
																</option>
																<option value='Guernsey'>
																	Guernsey
																</option>
																<option value='Ghana'>Ghana</option>
																<option value='Gibraltar'>
																	Gibraltar
																</option>
																<option value='Greenland'>
																	Greenland
																</option>
																<option value='Gambia'>
																	Gambia
																</option>
																<option value='Guinea'>
																	Guinea
																</option>
																<option value='Guadeloupe'>
																	Guadeloupe
																</option>
																<option value='Equatorial Guinea'>
																	Equatorial Guinea
																</option>
																<option value='Greece'>
																	Greece
																</option>
																<option value='South Georgia and the South Sandwich Islands'>
																	South Georgia and the South
																	Sandwich Islands
																</option>
																<option value='Guatemala'>
																	Guatemala
																</option>
																<option value='Guam'>Guam</option>
																<option value='Guinea-Bissau'>
																	Guinea-Bissau
																</option>
																<option value='Guyana'>
																	Guyana
																</option>
																<option value='Hong Kong'>
																	Hong Kong
																</option>
																<option value='Heard Island and McDonald Islands'>
																	Heard Island and McDonald
																	Islands
																</option>
																<option value='Honduras'>
																	Honduras
																</option>
																<option value='Croatia'>
																	Croatia
																</option>
																<option value='Haiti'>Haiti</option>
																<option value='Hungary'>
																	Hungary
																</option>
																<option value='Indonesia'>
																	Indonesia
																</option>
																<option value='Ireland'>
																	Ireland
																</option>
																<option value='Israel'>
																	Israel
																</option>
																<option value='Isle of Man'>
																	Isle of Man
																</option>
																<option value='India'>India</option>
																<option value='British Indian Ocean Territory'>
																	British Indian Ocean Territory
																</option>
																<option value='Iraq'>Iraq</option>
																<option value='Iceland'>
																	Iceland
																</option>
																<option value='Italy'>Italy</option>
																<option value='Jersey'>
																	Jersey
																</option>
																<option value='Jamaica'>
																	Jamaica
																</option>
																<option value='Jordan'>
																	Jordan
																</option>
																<option value='Japan'>Japan</option>
																<option value='Kenya'>Kenya</option>
																<option value='Kyrgyzstan'>
																	Kyrgyzstan
																</option>
																<option value='Cambodia'>
																	Cambodia
																</option>
																<option value='Kiribati'>
																	Kiribati
																</option>
																<option value='Comoros'>
																	Comoros
																</option>
																<option value='Saint Kitts and Nevis'>
																	Saint Kitts and Nevis
																</option>
																<option value='Kuwait'>
																	Kuwait
																</option>
																<option value='Cayman Islands'>
																	Cayman Islands
																</option>
																<option value='Kazakhstan'>
																	Kazakhstan
																</option>
																<option value="Lao People's Democratic Republic">
																	Lao People's Democratic Republic
																</option>
																<option value='Lebanon'>
																	Lebanon
																</option>
																<option value='Saint Lucia'>
																	Saint Lucia
																</option>
																<option value='Liechtenstein'>
																	Liechtenstein
																</option>
																<option value='Sri Lanka'>
																	Sri Lanka
																</option>
																<option value='Liberia'>
																	Liberia
																</option>
																<option value='Lesotho'>
																	Lesotho
																</option>
																<option value='Lithuania'>
																	Lithuania
																</option>
																<option value='Luxembourg'>
																	Luxembourg
																</option>
																<option value='Latvia'>
																	Latvia
																</option>
																<option value='Libyan Arab Jamahiriya'>
																	Libyan Arab Jamahiriya
																</option>
																<option value='Morocco'>
																	Morocco
																</option>
																<option value='Monaco'>
																	Monaco
																</option>
																<option value='Moldova :  Republic of'>
																	Moldova : Republic of
																</option>
																<option value='Montenegro'>
																	Montenegro
																</option>
																<option value='Saint Martin'>
																	Saint Martin
																</option>
																<option value='Madagascar'>
																	Madagascar
																</option>
																<option value='Marshall Islands'>
																	Marshall Islands
																</option>
																<option value='Macedonia'>
																	Macedonia
																</option>
																<option value='Mali'>Mali</option>
																<option value='Myanmar'>
																	Myanmar
																</option>
																<option value='Mongolia'>
																	Mongolia
																</option>
																<option value='Macao'>Macao</option>
																<option value='Northern Mariana Islands'>
																	Northern Mariana Islands
																</option>
																<option value='Martinique'>
																	Martinique
																</option>
																<option value='Mauritania'>
																	Mauritania
																</option>
																<option value='Montserrat'>
																	Montserrat
																</option>
																<option value='Malta'>Malta</option>
																<option value='Mauritius'>
																	Mauritius
																</option>
																<option value='Maldives'>
																	Maldives
																</option>
																<option value='Malawi'>
																	Malawi
																</option>
																<option value='Mexico'>
																	Mexico
																</option>
																<option value='Malaysia'>
																	Malaysia
																</option>
																<option value='Mozambique'>
																	Mozambique
																</option>
																<option value='Namibia'>
																	Namibia
																</option>
																<option value='New Caledonia'>
																	New Caledonia
																</option>
																<option value='Niger'>Niger</option>
																<option value='Norfolk Island'>
																	Norfolk Island
																</option>
																<option value='Nigeria'>
																	Nigeria
																</option>
																<option value='Nicaragua'>
																	Nicaragua
																</option>
																<option value='Netherlands'>
																	Netherlands
																</option>
																<option value='Norway'>
																	Norway
																</option>
																<option value='Nepal'>Nepal</option>
																<option value='Nauru'>Nauru</option>
																<option value='Niue'>Niue</option>
																<option value='New Zealand'>
																	New Zealand
																</option>
																<option value='Oman'>Oman</option>
																<option value='Panama'>
																	Panama
																</option>
																<option value='Peru'>Peru</option>
																<option value='French Polynesia'>
																	French Polynesia
																</option>
																<option value='Papua New Guinea'>
																	Papua New Guinea
																</option>
																<option value='Philippines'>
																	Philippines
																</option>
																<option value='Pakistan'>
																	Pakistan
																</option>
																<option value='Poland'>
																	Poland
																</option>
																<option value='Saint Pierre and Miquelon'>
																	Saint Pierre and Miquelon
																</option>
																<option value='Pitcairn'>
																	Pitcairn
																</option>
																<option value='Puerto Rico'>
																	Puerto Rico
																</option>
																<option value='Palestinian Territory'>
																	Palestinian Territory
																</option>
																<option value='Portugal'>
																	Portugal
																</option>
																<option value='Palau'>Palau</option>
																<option value='Paraguay'>
																	Paraguay
																</option>
																<option value='Qatar'>Qatar</option>
																<option value='Reunion'>
																	Reunion
																</option>
																<option value='Romania'>
																	Romania
																</option>
																<option value='Serbia'>
																	Serbia
																</option>
																<option value='Russian Federation'>
																	Russian Federation
																</option>
																<option value='Rwanda'>
																	Rwanda
																</option>
																<option value='Saudi Arabia'>
																	Saudi Arabia
																</option>
																<option value='Solomon Islands'>
																	Solomon Islands
																</option>
																<option value='Seychelles'>
																	Seychelles
																</option>
																<option value='Sudan'>Sudan</option>
																<option value='Sweden'>
																	Sweden
																</option>
																<option value='Singapore'>
																	Singapore
																</option>
																<option value='Saint Helena'>
																	Saint Helena
																</option>
																<option value='Slovenia'>
																	Slovenia
																</option>
																<option value='Svalbard and Jan Mayen'>
																	Svalbard and Jan Mayen
																</option>
																<option value='Slovakia'>
																	Slovakia
																</option>
																<option value='Sierra Leone'>
																	Sierra Leone
																</option>
																<option value='San Marino'>
																	San Marino
																</option>
																<option value='Senegal'>
																	Senegal
																</option>
																<option value='Somalia'>
																	Somalia
																</option>
																<option value='Suriname'>
																	Suriname
																</option>
																<option value='South Sudan'>
																	South Sudan
																</option>
																<option value='Sao Tome and Principe'>
																	Sao Tome and Principe
																</option>
																<option value='El Salvador'>
																	El Salvador
																</option>
																<option value='Sint Maarten'>
																	Sint Maarten
																</option>
																<option value='Syrian Arab Republic'>
																	Syrian Arab Republic
																</option>
																<option value='Swaziland'>
																	Swaziland
																</option>
																<option value='Turks and Caicos Islands'>
																	Turks and Caicos Islands
																</option>
																<option value='Chad'>Chad</option>
																<option value='French Southern Territories'>
																	French Southern Territories
																</option>
																<option value='Togo'>Togo</option>
																<option value='Thailand'>
																	Thailand
																</option>
																<option value='Tajikistan'>
																	Tajikistan
																</option>
																<option value='Tokelau'>
																	Tokelau
																</option>
																<option value='Timor-Leste'>
																	Timor-Leste
																</option>
																<option value='Turkmenistan'>
																	Turkmenistan
																</option>
																<option value='Tunisia'>
																	Tunisia
																</option>
																<option value='Tonga'>Tonga</option>
																<option value='Turkey'>
																	Turkey
																</option>
																<option value='Trinidad and Tobago'>
																	Trinidad and Tobago
																</option>
																<option value='Tuvalu'>
																	Tuvalu
																</option>
																<option value='Taiwan'>
																	Taiwan
																</option>
																<option value='Tanzania :  United Republic of'>
																	Tanzania : United Republic of
																</option>
																<option value='Ukraine'>
																	Ukraine
																</option>
																<option value='Uganda'>
																	Uganda
																</option>
																<option value='United States Minor Outlying Islands'>
																	United States Minor Outlying
																	Islands
																</option>
																<option value='United States'>
																	United States
																</option>
																<option value='Uruguay'>
																	Uruguay
																</option>
																<option value='Uzbekistan'>
																	Uzbekistan
																</option>
																<option value='Holy See (Vatican City State)'>
																	Holy See (Vatican City State)
																</option>
																<option value='Saint Vincent and the Grenadines'>
																	Saint Vincent and the Grenadines
																</option>
																<option value='Venezuela'>
																	Venezuela
																</option>
																<option value='Vietnam'>
																	Vietnam
																</option>
																<option value='Vanuatu'>
																	Vanuatu
																</option>
																<option value='Wallis and Futuna'>
																	Wallis and Futuna
																</option>
																<option value='Samoa'>Samoa</option>
																<option value='Yemen'>Yemen</option>
																<option value='Mayotte'>
																	Mayotte
																</option>
																<option value='South Africa'>
																	South Africa
																</option>
																<option value='Zambia'>
																	Zambia
																</option>
																<option value='Zimbabwe'>
																	Zimbabwe
																</option>
															</Input>
														</Col>
													</Row>
													<Row>
														<Col>
															<Button
																onClick={() => {
																	this.downloadUsados();
																}}
																color='info'
																className='animation-on-hover'
															>
																Descargar Usados
															</Button>
														</Col>
														<Col>
															<Input
																placeholder='Cantidad'
																onChange={this.handleCantidad.bind(
																	this
																)}
																type='number'
															/>
														</Col>
													</Row>
												</td>
											</tr>
										</tbody>
									</Table>
								</CardBody>
							</Card>
						</Col>
					</Row>

					<Row>
						<Col lg='6' md='12'>
							<Table responsive>
								<thead>
									<tr>
										<th className='text-center'>#</th>
										<th className='text-center'>Usuario</th>
										<th className='text-center'>Contraseña</th>
									</tr>
								</thead>
								<tbody>
									{this.state.usedProfiles.map((profile, index) => {
										return (
											<tr key={index}>
												<td className='text-center'>{index}</td>
												<td className='text-left'>{profile.user}</td>
												<td className='text-left'>{profile.user}</td>
											</tr>
										);
									})}
								</tbody>
							</Table>
						</Col>
						<Col lg='6' md='12'>
							<Table responsive>
								<thead>
									<tr>
										<th className='text-center'>#</th>
										<th className='text-center'>Link</th>
									</tr>
								</thead>
								<tbody>
									{this.state.usedLink.map((link, index) => {
										return (
											<tr key={index}>
												<td className='text-center'>{index}</td>
												<td className='text-center'>{link.link}</td>
											</tr>
										);
									})}
								</tbody>
							</Table>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default Galleta;
